import React from "react";
import { Navigate, useLocation } from "react-router-dom";

import Unauthorized from "@/features/auth/views/unauthorized";
import { useUserProfile } from "@/core/api/queries";

type Props = {
    children: JSX.Element;
    roles: string[];
};

export default function ProtectedRoute({ children, roles = ['*'] }: Props) {
    const location = useLocation();
    const token =
        typeof window !== "undefined" ? localStorage.getItem("_jwt_fto") : null;

    const userProfile = useUserProfile();

    if (!token) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    if (userProfile.isLoading) {
        return null;
    }

    if (userProfile.isFetched && !roles.includes('*') && !roles.includes(userProfile.data?.role)) {
        return <Unauthorized />
    }

    if (userProfile.isError || !userProfile.data) {
        return <Navigate to="/login" state={{ from: location }} replace />;
    }

    return children;
}
